import { IContextualMenuProps } from '@fluentui/react';
import { IPFontIcon, IPIconButton, IPText } from 'baseComponents';
import { IPContextualMenuItemType } from 'baseComponents/ContextualMenu/IPContextualMenu';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { checkIcon, globalStackTokensGapSmall, moreIcon } from 'globalStyles';
import { ComboBoxItem } from 'models/combobox/ComboBoxItem';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import './ComboBoxListItemRowStyles.css';

export interface ComboBoxCalloutInformation {
  item: ComboBoxItem;
  buttonId: string;
}

interface IComboBoxListItemRow {
  index: number;
  statusButtonId: string;
  editButtonId: string;
  showIcon: number | undefined;
  callOutInfo?: ComboBoxCalloutInformation;
  item: ComboBoxItem;
  isDefault: boolean;
  allowEdit: boolean;
  setShowIcon: (_itm: number | undefined) => void;
  onDelete: (item: ComboBoxItem) => void;
  setDefault: (item: ComboBoxItem | undefined) => void;
  setCallOutNameInfo: (item: ComboBoxCalloutInformation | undefined) => void;
  setCallOutKeyInfo: (item: ComboBoxCalloutInformation | undefined) => void;
}

export const ComboBoxListItemRow = (props: IComboBoxListItemRow) => {
  const { t } = useTranslation(['translation', 'comboBoxItem']);
  const itemEditMenuProps: IContextualMenuProps = {
    items: [
      {
        key: 'editKey',
        text: t('comboBoxItem:ComboBoxList.Operations.EditKey'),
        onClick: () => {
          if (!props.item) return;

          props.setCallOutKeyInfo({ item: props.item, buttonId: props.editButtonId });
        },
      },
      {
        key: 'editName',
        text: t('comboBoxItem:ComboBoxList.Operations.EditName'),
        onClick: () => {
          if (!props.item) return;

          props.setCallOutNameInfo({ item: props.item, buttonId: props.editButtonId });
        },
      },
      {
        key: 'setDefault',
        text: t('comboBoxItem:ComboBoxList.Operations.SetDefault'),
        canCheck: true,
        checked: props.isDefault,
        onClick: () => {
          if (!props.item) return;

          props.setDefault(props.isDefault ? undefined : props.item);
        },
      },
      {
        key: 'div1',
        text: '-',
        itemType: IPContextualMenuItemType.Divider,
      },
      {
        key: 'delete',
        text: t('comboBoxItem:ComboBoxList.Operations.Remove'),
        onClick: () => {
          if (!props.item) return;
          props.onDelete(props.item);
        },
      },
    ],
    directionalHintFixed: true,
    beakWidth: 0,
  };

  const getOperationOptions = () => {
    if (props.showIcon !== props.index) return null;

    return (
      <Fragment>
        {props.allowEdit && (
          <IPIconButton iconProps={moreIcon} menuProps={itemEditMenuProps} onRenderMenuIcon={() => null} />
        )}
      </Fragment>
    );
  };

  const getDefault = () => {
    if (props.showIcon === props.index) return null;
    if (!props.isDefault) return null;

    return (
      <Fragment>
        <IPFontIcon {...checkIcon} style={{ fontSize: 18 }} />
      </Fragment>
    );
  };

  return (
    <IPStack
      grow
      horizontal
      tokens={globalStackTokensGapSmall}
      verticalAlign="center"
      onMouseOver={() => {
        props.setShowIcon(props.index);
      }}
      onMouseLeave={() => {
        props.setShowIcon(undefined);
      }}
      id={props.editButtonId}
      styles={{ root: { height: '35px' } }}
    >
      <IPStack.Item>
        {props.allowEdit && props.showIcon === props.index && <div className="row-drag-handle"></div>}
      </IPStack.Item>
      <IPStack.Item>
        <IPText nowrap>{props.item.key.toString()}</IPText>
      </IPStack.Item>
      <IPStack.Item>
        <IPText>{' - '}</IPText>
      </IPStack.Item>
      <IPStack.Item styles={{ root: { width: '100%' } }}>
        <IPText styles={{ root: { whiteSpace: 'pre-wrap' } }}>{props.item.description}</IPText>
      </IPStack.Item>
      <IPStack.Item>{getOperationOptions()}</IPStack.Item>
      <IPStack.Item>{getDefault()}</IPStack.Item>
    </IPStack>
  );
};
